import type { AppDataTableColumn } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { AppBadge, AppMemberDisplay, AppTooltip } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import type { ProjectMemberResponse } from 'backend/types'
import { COLOR_CATEGORY, getColor } from '@/lib/color-registry'
import { formatDate, toDateTime } from '@/lib/format-utils'

/**
 * メンバー一覧のカラム定義を生成
 * @returns カラム定義の配列
 */
export function createMemberColumns(): AppDataTableColumn<ProjectMemberResponse>[] {
  return [
    {
      key: 'id',
      label: 'ID',
      accessor: (row) => row.id,
      cellClassName: 'hidden',
      headerClassName: 'hidden',
    },
    {
      key: 'memberName',
      label: 'メンバー名',
      accessor: (row) => row.memberName,
      render: (row) => <AppMemberDisplay employeeNumber={row.employeeNumber} name={row.memberName} />,
    },
    {
      key: 'salesforceProjectMemberTypeName',
      label: '役職名',
      accessor: (row) => row.salesforceProjectMemberTypeName,
      sortable: false,
      render: (row) => (
        <div className='flex items-center gap-2'>
          <AppBadge
            color={getColor(COLOR_CATEGORY.ROLE, row.salesforceProjectMemberTypeId)}
            className='text-xs w-12.5 text-center inline-block'
          >
            {row.salesforceProjectMemberTypeShortName}
          </AppBadge>
          <span>{row.salesforceProjectMemberTypeName}</span>
        </div>
      ),
    },
    {
      key: 'expiredOn',
      label: '有効期限',
      accessor: (row) => row.expiredOn,
      sortable: false,
      render: (row) =>
        row.expiredOn ? <span>{formatDate(row.expiredOn)}</span> : <AppBadge color='green'>指定なし</AppBadge>,
    },
    {
      key: 'updatedAt',
      label: '更新日時',
      accessor: (row) => row.updatedAt,
      render: (row) => {
        if (!row.updatedAt) return '-'
        return (
          <AppTooltip content={toDateTime(row.updatedAt)?.toFormat('yyyy/MM/dd HH:mm:ss') ?? '-'}>
            <span className='cursor-help text-muted-foreground'>{formatDate(row.updatedAt, 'relative')}</span>
          </AppTooltip>
        )
      },
    },
    {
      key: 'createdAt',
      label: '作成日時',
      accessor: (row) => row.createdAt,
      render: (row) => {
        if (!row.createdAt) return '-'
        return (
          <AppTooltip content={toDateTime(row.createdAt)?.toFormat('yyyy/MM/dd HH:mm:ss') ?? '-'}>
            <span className='cursor-help text-muted-foreground'>{formatDate(row.createdAt, 'relative')}</span>
          </AppTooltip>
        )
      },
    },
  ]
}
